module.exports = __webpack_public_path__ + "img/bnb.59eb600c.png";